export interface PollsAction {
  type: string
  payload: any
}

export enum Actions {
  ADD = "ADD",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  DOWNLOAD_POLLS = "DOWNLOAD_POLLS",
  TOGGLE = "TOGGLE",
  RESET = "RESET",
  CREATE_POLL = "CREATE_POLL",
  TOGGLE_POLL_MOBILE = "TOGGLE_POLL_MOBILE",
  DELETE_POLL = "DELETE_POLL"
}
